module.exports = __webpack_public_path__ + "static/img/dolomite.d8fdd54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/dolomite.jpg
// module id = IO2M
// module chunks = 1